/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Access_Creator_NamedInputs */



/**
* | output |
* | --- |
* | "{name}, who set up this agent" |
*
* @param {Agent_Access_Creator_NamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_creator_named = /** @type {((inputs: Agent_Access_Creator_NamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Creator_NamedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`die Person, die diesen Agenten eingerichtet hat (${i?.name})`)
	return /** @type {LocalizedString} */ (`${i?.name}, who set up this agent`)
});